module.exports = __webpack_public_path__ + "img/9788934993247.ba4237b5.jpg";